import Editor from "@monaco-editor/react";

export default function CodeEditor(props) {
    return (
        <Editor
            defaultLanguage="json"
            defaultValue={ props.defaultValue }
            height={ props.height ?? "100%" }
            options={
                {
                    automaticLayout: true,
                    padding: {
                        bottom: 100,
                    },
                    scrollBeyondLastLine: false,
                }
            }
            onChange={ props.onChange }
            value={ props.value }
        />
    );
}
